module.exports = __webpack_public_path__ + "img/icon_5_33.730cb285.png";